import { render, staticRenderFns } from "./BaseDottedText.vue?vue&type=template&id=17d86e0f&scoped=true"
import script from "./BaseDottedText.vue?vue&type=script&lang=js"
export * from "./BaseDottedText.vue?vue&type=script&lang=js"
import style0 from "./BaseDottedText.vue?vue&type=style&index=0&id=17d86e0f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17d86e0f",
  null
  
)

export default component.exports